import React, { useState } from "react";
import MessageList from "./MessageList";
import MessageContent from "./MessageContent";

const MessagesSection = () => {
  // const [search, setSearch] = useState("");
  const [activeChat, setActiveChat] = useState(null);
  // const contacts = [
  //   { name: "Nitesh Chowdhary", message: "Nitesh sent an attachment", date: "Feb 24", avatar: "https://via.placeholder.com/40" },
  //   { name: "Dilsha Mujeeb", message: "Hello i'm interested in working at your company....", date: "May 20, 2024", avatar: "https://via.placeholder.com/40" },
  //   { name: "Aniket Paul", message: "Hello", date: "Sep 29, 2023", avatar: "https://via.placeholder.com/40" },
  // ];

  // const suggestedContacts = [
  //   { name: "Subhajit Saha", title: "Sr. Frontend HTML Developer at Symlink Technologies LLP", avatar: "https://via.placeholder.com/40" },
  //   { name: "Buddhadev Haldar", title: "mern stack | web developer", avatar: "https://via.placeholder.com/40" },
  //   { name: "PROKASH MALO", title: "Full Stack Developer (MERN) with QA Expertise", avatar: "https://via.placeholder.com/40" },
  //   { name: "Animesh Manna", title: "Founder of jsonviewer.tools | Building StructViz", avatar: "https://via.placeholder.com/40" },
  //   { name: "Sujay Mondal", title: "Project Manager & Technical Head", avatar: "https://via.placeholder.com/40" },
  //   { name: "MD Sakil Ahmed", title: "Frontend web developer | ReactJs", avatar: "https://via.placeholder.com/40" },
  //   { name: "Ravish Kumar", title: "Software Developer", avatar: "https://via.placeholder.com/40" },
  // ];

  return (
    <section className="flex flex-col md:flex-row">
      {/* Left side (Message List) */}
      <div className="w-full md:w-[30%]">
        <MessageList onSelectChat={setActiveChat} />
      </div>

      {/* Right side (Suggested Contacts) */}
      <div className="w-full md:w-[70%]">
        <MessageContent activeChat={activeChat} />
      </div>
    </section>
  );
};

export default MessagesSection;
